module.exports = __webpack_public_path__ + "img/DK21627747.c21c690a.png";